import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";

import app from "./reducers/index";
import Root from "./components/Root";

import * as serviceWorker from "./serviceWorker";
// NOTE for translate component
// import './i18n';

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import "./styles/custom.scss";
import "./index.scss";

const store = createStore(app, applyMiddleware(thunk));

ReactDOM.render(
    <Provider store={store}>
        <Router basename="/">
            <Root />
        </Router>
    </Provider>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();